import React, { Component } from 'react';
import { connect } from 'react-redux';
import "../styles/DrawerDropDownMenu.css"
import { reasons } from "../data"
import { formInput } from "actions/FormActions"
import { GetProductInventoryLog } from 'actions/EntityActions';
import Button from 'screens/components/basic/Button';
import IconButton from '@mui/material/IconButton';
import CachedIcon from '@mui/icons-material/Cached';
// import AutorenewIcon from '@mui/icons-material/Autorenew';

class DrawerDropDownMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      resetCount: 0
    };
  }

  resetForm = () => {
    this.props.formInput("", "fromDate");
    this.props.formInput("", "toDate");
    this.props.formInput(null, "reason");
    this.setState((prevState) => ({ resetCount: prevState.resetCount + 1 }));
  };

  searchNewInventory = () => {
    this.props.GetProductInventoryLog({
      ProductId: this.props.currentProduct,
      BranchId: this.props.currentBranch,
      StartDate: this.props.StartDate,
      EndDate: this.props.EndDate,
      Reason: this.props.Reason === "" || !this.props.Reason ? null : this.props.Reason,
      ItemsPerPage: 100,
      PageNumber: 1
    });
  }

  render() {
    const p = this.props;
    return (
      <section className="menu-section">
        {/* Dropdown menus for location, date picker, and reasons -------------------------------- */}
        <div className="menu-items">
          {/* Date picker---------------------------------------------------------------------------*/}
          <div className="date-picker">
            <input
              name="fromDate"
              type="date"
              value={p.StartDate}
              onChange={(e) => p.handleDateChange(e, true)}
              className="from-date"
            />
            <label className="date-separator"> ~ </label>
            <input
              name="toDate"
              type="date"
              value={p.EndDate}
              onChange={(e) => p.handleDateChange(e, false)}
              className="to-date"
            />
          </div>
          {/* stock reason dropdown -----------------------------------------------------------------*/}
          <select
            name="reason"
            key={this.state.resetCount}
            onChange={p.onChange}
            className="product-type-dropdown">
            {reasons.map((reason) => (
              <option key={reason.id} value={reason.id === 0 ? "" : reason.value}>
                {reason.name}
              </option>
            ))}
          </select>
          <div className="action-buttons">
            <Button
              className="btnNewBrandPOS"
              type="RaisedButton"
              id='buttonApplyFilter'
              label="Apply Filter"
              onTouchTap={this.searchNewInventory}
            />
            <Button
              type="IconButton"
              className="pl-1 btnNewBrandPOS"
              icon={<CachedIcon />}
              onTouchTap={this.resetForm}
            />
            <Button
              type="DownloadButton"
              className="pl-1 btnNewBrandPOS"
              id='buttonDownloadProductCSV'
              label="CSV"
              onTouchTap={p.download}
            />
          </div>
        </div>
      </section>
    );
  }
}


const mapStateToProps = state => {
  return {
    StartDate: state.form.fromDate || "",
    EndDate: state.form.toDate || "",
    Reason: state.form.reason || "",
    currentBranch: state.form.clickedBranch,
    currentProduct: state.form.clickedProduct
  };
};

const mapDispatchToProps = dispatch => {
  return {
    GetProductInventoryLog: model => dispatch(GetProductInventoryLog(model)),
    formInput: (value, name) => dispatch(formInput(value, name))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DrawerDropDownMenu)
